import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { LayoutDashboard, KeyRound, Users, GraduationCap, FileBarChart, Palette, LayoutTemplate, Activity, Zap } from "lucide-react";
import { api } from "@/lib/api";

const NAV = () => [
  { to: `/app/partner`, label: "Panel", icon: LayoutDashboard, end: true },
  { to: `/app/partner/licencias`, label: "Licencias", icon: KeyRound },
  { to: `/app/partner/alumnos`, label: "Alumnos", icon: Users },
  { to: `/app/partner/cohortes`, label: "Cohortes", icon: GraduationCap },
  { to: `/app/partner/landing`, label: "Landing", icon: LayoutTemplate },
  { to: `/app/partner/reportes`, label: "Reportes", icon: FileBarChart },
  { to: `/app/partner/integraciones`, label: "Integraciones", icon: Zap },
  { to: `/app/partner/actividad`, label: "Actividad", icon: Activity },
  { to: `/app/partner/configuracion`, label: "Configuración", icon: Palette },
];

// Legacy helper (compat with Fase <14.2 code paths).
export function tenantSlugFor(user) {
  if (!user?.email) return "banco-alfa";
  if (user.email.includes("demo-bank")) return "demo-bank";
  if (user.email.includes("trafalgar-cb") || user.email.endsWith("@trafalgar-cb.mx")) return "trafalgar-cb";
  if (user.email.includes("trafalgar-sofipo") || user.email.endsWith("@trafalgar-sofipo.mx")) return "trafalgar-sofipo";
  if (user.email === "rh@trafalgar.mx") return "trafalgar-sofipo"; // primary por default
  return "banco-alfa";
}

// Fase 14.2: hook que resuelve el slug del tenant ACTIVO del user via my-tenants.
// Cachea en localStorage para minimizar network.
export function usePartnerActiveTenant(user) {
  const [slug, setSlug] = useState(null);
  useEffect(() => {
    if (!user) return;
    // Try cache
    const cached = localStorage.getItem("dcc_active_tenant_slug");
    if (cached) setSlug(cached);
    api.get("/auth/my-tenants").then((r) => {
      const items = r.data.items || [];
      const active = items.find((t) => t.id === r.data.active_tenant_id) || items[0];
      if (active) {
        setSlug(active.slug);
        localStorage.setItem("dcc_active_tenant_slug", active.slug);
      }
    }).catch(() => {});
  }, [user?.id]);
  return slug;
}

export default function PartnerLayout({ user, children }) {
  const activeSlug = usePartnerActiveTenant(user);
  const slug = activeSlug || tenantSlugFor(user);
  return (
    <DashboardLayout title="Partner Admin" navItems={NAV()} tenantSlug={slug}>
      {children}
    </DashboardLayout>
  );
}
